<div class="wrapper-md" *ngIf="isReady">
    <app-breadcrumbs [items]="[
                     { url: '/bc-contests/apply', text: 'bcContestApply_title' },
                     { url: currentUrl, text: 'bcContestApply_courseSelectTitle' }
                     ]"></app-breadcrumbs>

    <header class="content-header">
        <h1>{{'bcContestApply_courseSelectTitle' | translate}}</h1>
    </header>

    <app-alert level="info" *ngIf="student">
        <div>
            {{'bcContestApply_lblRequiredCreditPoints' | translate}}: <strong>{{student.CreditPoints | number:'1.0-2'}}</strong> ({{requiredEcts | number:'1.0-2'}} ECTS)
        </div>
        <div *ngIf="pointsExtraInfoHtml" [innerHTML]="pointsExtraInfoHtml | safeHtml"></div>
    </app-alert>

    <section class="block">
        <form>
            <div class="row">
                <div class="form-field col-md-6">
                    <input class="form-control" autofocus [placeholder]="'bcContestApply_filterText' | translate"
                           [(ngModel)]="filters.text" name="filterText">
                </div>

                <div class="form-field col-md-3">
                    <app-select [placeholder]="'bcContestApply_filterLanguage' | translate"
                                [options]="filters.language.options"
                                [(ngModel)]="filters.language.value" name="filterLanguage">
                    </app-select>
                </div>
            </div>

            <ng-container *ngIf="isFilterExtended">
                <div class="row">
                    <div class="form-field col-md-6">
                        <input class="form-control" [placeholder]="'bcContestApply_filterAddress' | translate"
                               [(ngModel)]="filters.address" name="filterAddress">
                    </div>

                    <div class="form-field col-md-6">
                        <input class="form-control" [placeholder]="'bcContestApply_filterManager' | translate"
                               [(ngModel)]="filters.manager" name="filterManager">
                    </div>
                </div>

                <div class="row">
                    <div class="form-field col-md-6">
                        <app-select [placeholder]="'bcContestApply_filterExamType' | translate"
                                    [options]="filters.examinationType.options"
                                    [(ngModel)]="filters.examinationType.value" name="filterExaminationType">
                        </app-select>
                    </div>
                </div>
            </ng-container>

            <div class="form-field">
                <app-checkbox [(ngModel)]="filters.onlyAdded" name="filterOnlyAdded">
                    {{'bcContestApply_lblOnlyAddedCourses' | translate}}
                </app-checkbox>
            </div>

            <div class="mb-3">
                <button class="btn btn-outline" type="button" (click)="isFilterExtended = !isFilterExtended">
                    <i [class]="extendedFilter ? 'fi fi-rs-angle-up' : 'fi fi-rs-angle-down'"></i>
                    {{'bcContestApply_btnAdvancedFilter' | translate}}
                </button>

                <button class="btn btn-outline" type="button" (click)="clearFilter()">
                    <i class="fi fi-rs-cross"></i>
                    {{'bcContestApply_btnClearFilter' | translate}}
                </button>
            </div>
        </form>
    </section>

    <ng-container *ngIf="isReady">
        <app-alert level="warning" *ngIf="!courses.length">
            {{'bcContestApply_noCourseAvailable' | translate}}
        </app-alert>

        <app-alert level="warning" *ngIf="courses.length && !filteredCourses.length">
            {{'bcContestApply_courseFilterResultEmpty' | translate}}
        </app-alert>

        <app-bc-contest-course-card *ngFor="let c of filteredCourses"
                                    [course]="c"
                                    [studentId]="studentId"
                                    [warning]="!c.ApplicationId && isLimitReached ? limitWarning : null"
                                    [disabled]="!c.ApplicationId && isLimitReached"
                                    (add)="onAdd(c)"
                                    (remove)="onRemove(c)"></app-bc-contest-course-card>
    </ng-container>

    <div class="form-actions">
        <button type="button" class="btn btn-primary" (click)="finish()">
            {{'bcContestApply_btnFinishCourses' | translate}}
        </button>
    </div>
</div>
